<template>
  <div>

    <v-flex class="ml-1 mb-0">
      <h3 class="xs12 flex">Costs</h3>
      <!-- <b>Total Expense:</b> {{expenseSummary}} EUR - <b>Total Income:</b> {{incomeSummary}} EUR -->
    </v-flex>

    <v-data-table
      :headers="headers"
      :items="this.artwork.artwork_costs ? this.artwork.artwork_costs.filter(c => c.category === 'cost') : []"
      hide-actions class="elevation-1 mx-0"
     >
      <template slot="items" slot-scope="props">
        <td class="py-2 text-xs-left">{{ props.item.what_for }}</td>
        <td class="py-2 text-xs-left">{{ props.item.cost ? formatMoney(props.item.cost) : ' - ' }} {{ props.item.cost ? 'EUR' : ''}}</td>
        <td class="py-2 text-xs-left">{{ props.item.content }}</td>
        <td class="py-2 text-xs-left">{{ getUser(props.item.created_by).abb }}</td>
        <td class="py-2 text-xs-left">{{ props.item.transaction_date }}</td>
        <td class="">
          <!-- <v-btn flat icon v-if="c_user.edit"><v-icon small @click="editItem(props.item)">edit</v-icon></v-btn> -->
          <v-btn small flat icon ma-0>
            <v-icon small @click="editCost(props.item)">edit</v-icon>
          </v-btn>
          <v-btn small flat icon v-if="c_user.delete_rights"><v-icon small @click="deleteItem(props.item)">delete</v-icon></v-btn>
        </td>
      </template>
      <!-- <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template> -->
    </v-data-table>

    <v-flex class="ml-1 mt-4 mb-0">
      <h3 class="xs12 flex">Other</h3>
      <!-- <b>Total Expense:</b> {{expenseSummary}} EUR - <b>Total Income:</b> {{incomeSummary}} EUR -->
    </v-flex>

    <v-data-table
      :headers="headers_other"
      :items="this.artwork.artwork_costs ? this.artwork.artwork_costs.filter(c => c.category === 'other') : []"
      hide-actions class="elevation-1 mx-0"
     >
      <template slot="items" slot-scope="props">
        <td class="py-2 text-xs-left">{{ props.item.what_for }}</td>
        <!-- <td class="py-2 text-xs-left">{{ props.item.cost }} {{ props.item.cost ? 'EUR' : ''}}</td> -->
        <td class="py-2 text-xs-left">{{ props.item.content }}</td>
        <td class="py-2 text-xs-left">{{ getUser(props.item.created_by).abb }}</td>
        <td class="py-2 text-xs-left">{{ props.item.transaction_date }}</td>
        <td class="">
          <v-btn flat icon><v-icon small @click="editCost(props.item)">edit</v-icon></v-btn>
          <v-btn flat icon><v-icon small @click="deleteItem(props.item)">delete</v-icon></v-btn>
        </td>
      </template>
      <!-- <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template> -->
    </v-data-table>

    <!-- <v-dialog v-model="dialog2" max-width="400px"> -->
      <v-btn color="primary" @click="showDialog=true" class="right mx-3 mt-3 mb-0" small><v-icon small class="mr-2">add</v-icon> Add Cost or Conditions</v-btn>
      <v-card v-if="showDialog" class="my-3 mx-4 pr-3 pt-0 elevation-1" style="background-color:#eee;">
        <v-card-title class="px-4 pb-0 mb-0">
          <span class="headline pt-1">New Cost/Conditions</span>
        </v-card-title>
        <v-card-text class="mx-0 px-0 my-0 py-0">
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs6 mb-1>
                <v-radio-group v-model="loan_condition.category" row>
                  <v-radio class="flex pl-2" value="cost" color="black" name="Cost" label="Cost"></v-radio>
                  <v-radio class="flex pl-2" value="other" color="black" name="Other" label="Conditions"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs6 mb-2 v-if="loan_condition.category!='other'">
                <v-text-field v-model="loan_condition.cost" class="flex pl-2" type="number" suffix=" EUR" name="cost"   label="Cost"></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 ml-2 mb-2>
                <div class="subheading mb-2">Transaction Date</div>
                <v-date-picker v-model="loan_condition.transaction_date" class="mb-3" full-width landscape name="transaction_date" label="Transaction Date"></v-date-picker>
              </v-flex> -->
              <v-flex xs12 mb-2>
                <v-text-field v-model="loan_condition.what_for"  class="flex pl-2" name="what_for"  label="What for"></v-text-field>
              </v-flex>
              <!-- <v-flex xs6 mb-2>
                <v-text-field v-model="loan_condition.cost"   class="flex pl-2" suffix=" EUR" name="cost"   label="Expense"></v-text-field>
              </v-flex> -->
              <v-flex xs12>
                <v-textarea rows=1 v-model="loan_condition.content" class="flex xs12 ml-2" auto-grow name="content" label="Note"></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-3 pb-4">
          <v-spacer></v-spacer>
          <v-btn small outline color="black" class="mr-3" @click.native="showDialog=false">Cancel</v-btn>
          <v-btn small color="black" dark @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    <!-- </v-dialog> -->

  </div>
</template>

<script>
  import { serverBus } from '../../main'
  import axios from '@/utils/apiClient'
  function dynamicSort (property) {
    var sortOrder = 1
    if (property[0] === '-') {
      sortOrder = -1
      property = property.substr(1)
    }
    return function (a, b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
      return result * sortOrder
    }
  }
  export default {
    props: ['artwork'],
    data: () => ({
      costs: [],
      other: [],
      editing: false,
      showDialog: false,
      selected: [],
      dialog: false,
      dialog2: false,
      headers: [
        { text: 'What for', value: 'what_for', sortable: true },
        { text: 'Cost', value: 'cost', sortable: true },
        { text: 'Notes', value: 'content', sortable: true },
        { text: 'Created by', value: 'created_by', sortable: true },
        { text: 'Transaction Date', value: 'transaction_date', sortable: true },
        { text: false, sortable: false }
      ],
      headers_other: [
        { text: 'What for', value: 'what_for', sortable: true },
        { text: 'Notes', value: 'content', sortable: true },
        { text: 'Created by', value: 'created_by', sortable: true },
        { text: 'Transaction Date', value: 'transaction_date', sortable: true },
        { text: false, sortable: false }
      ],
      editedIndex: -1,
      show: false,
      showUpload: false,
      loan_condition: {
        what_for: '',
        transaction_date: '',
        cost: '',
        content: '',
        category: 'cost',
        artwork_id: ''
      }
    }),
    computed: {
      c_user () {
        return this.$store.state.user.profile
      },
      incomeSummary () {
        // console.log('income')
        // console.log(this.artwork.loan_conditions)
        // console.log(this.artwork.loan_conditions.length)
        if (this.artwork.loan_conditions && this.artwork.loan_conditions.length > 0) {
          var out = this.artwork.artwork_costs.filter(function (ac) {
            if (ac.cost) {
              // console.log(ac.cost)
              return ac.cost > 0
            } else {
              return ''
            }
          })
          // console.log(out)
          if (out && out.length > 0) {
            return out.map(o => o.income).reduce((a, c) => a + c)
          } else {
            return 0
          }
        }
        // .reduce((a,b) => a + b, 0)
      },
      expenseSummary () {
        // console.log('cost')
        // console.log(this.artwork.loan_conditions)
        // console.log(this.artwork.loan_conditions.length)
        if (this.artwork.loan_conditions && this.artwork.loan_conditions.length > 0) {
          var out = this.artwork.loan_conditions.filter(function (ac) {
            if (ac.cost) {
              // console.log(ac.cost)
              return ac.cost > 0
            } else {
              return ''
            }
          })
          // console.log(out.map(o=>o.cost).reduce((a,c)=>a+c))
          if (out && out.length > 0) {
            return out.map(o => o.cost).reduce((a, c) => a + c)
          } else {
            return 0
          }
        }
        // .reduce((a,b) => a + b, 0)
      },
      all_loan_conditions () {
        return this.$store.state.loan_conditions
        // console.log(todos)
        // return todos
      }
      // selection_items () {
      //   var artworkLocations = Object.assign([], this.$store.getters.current_locations)
      //   return artworkLocations.sort(dynamicSort('name'))
      // }
    },
    methods: {
      editCost (c) {
        this.loan_condition = {
          what_for: '',
          transaction_date: '',
          income: '',
          expense: '',
          content: '',
          artwork_id: ''
        }
        this.editing = true
        try {
          this.loan_condition = Object.assign(
            {},
            this.artwork.artwork_costs.find(t => t.id === c.id)
          )
          this.loan_condition.transaction_date = this.format_date(
            this.loan_condition.transaction_date
              ? this.loan_condition.transaction_date
              : Date.now
          )
          this.showDialog = true
        } catch (error) {
          // console.log(error.message)
        }
      },
      load_costs () {
        this.costs = this.artwork.artwork_costs.filter(c => c.category === 'costs')
      },
      load_other () {
        this.other = this.artwork.artwork_costs.filter(c => c.category === 'other')
      },
      initialize () {},
      deleteItem (item) {
        confirm('Are you sure you want to delete this Loan Condition?')
        this.delete_loan_condition(item)
      },
      delete_loan_condition (item) {
        serverBus.$emit('showSnackbar', 'Deleting Cost.', 'black')
        let url = `${this.$globals.apiserver}/artwork_costs/${item.id}.json`
        axios
          .delete(url, item)
          .then(response => {
            serverBus.$emit('showSnackbar', 'Cost Deleted.', 'green')
            this.errors = {}
            const index = this.artwork.artwork_costs.indexOf(item)
            if (index >= 0) this.artwork.artwork_costs.splice(index, 1)
            this.$store.dispatch('updateArtwork', this.artwork.id)
          })
          .catch(error => {
            serverBus.$emit('showSnackbar', 'There was an Error deleting Cost.', 'red')
            this.errors = error.response.data
          })
      },
      // get_visa_status (loanCondition) {
      //   var vss = this.constants.VISA_STATUSES.filter(vs => vs.id === loanCondition.visa_status)
      //   if (vss[0] !== undefined) {
      //     return vss[0].id > 0 ? vss[0].name : ''
      //   } else {
      //     return ''
      //   }
      // },
      getUser (userId) {
        var l = this.$store.state.users.find(u => u.id === userId)
        return l ? l : ''
      },
      save () {
        serverBus.$emit('showSnackbar', 'Saving Loan Condition ...', 'green')
        this.loan_condition.artwork_id = this.artwork.id
        this.loan_condition.created_by = this.c_user.id
        // this.loan_condition.id = this.findMinMax(this.all_loan_conditions)+1
        if (!this.artwork.artwork_costs) {
          this.artwork.artwork_costs = []
        }
        // this.artwork.artwork_loan_conditions.push(this.loan_condition)
        if (!this.editing) {
          axios
            .post(`${this.$globals.apiserver}/artwork_costs.json`, {
              artwork_cost: this.loan_condition
              // loan_condition: this.loan_condition
            })
            .then(response => {
              this.errors = {}
              this.artwork.artwork_costs.push(response.data)
            // this.$store.commit('ADD_COST', response.data)
            })
            .catch(error => {
              serverBus.$emit('showSnackbar', 'There was an Error saving Loan Condition.', 'red')
              this.errors = error.response.data
            })
        // this.all_loan_conditions.push(this.loan_condition)
        // this.showUpload=!this.showUpload
          this.showDialog = false
          this.loan_condition = {
            what_for: '',
            transaction_date: '',
            // cost: '',
            cost: '',
            content: ''
          }
        } else {
          let url = `${this.$globals.apiserver}/artwork_costs/${this.loan_condition.id}.json`
          axios
            .put(url, {
              artwork_cost: this.loan_condition
            })
            .then(response => {
              serverBus.$emit('showSnackbar', 'Loan Condition Saved.', 'green')
              this.errors = {}
              this.artwork.artwork_costs = [
                ...this.artwork.artwork_costs.map(item =>
                  item.id !== response.data.id
                    ? item
                    : { ...item, ...response.data }
                )
              ]
              this.editing = false
              this.showDialog = false
              // this.$store.commit("SAVE_COST", response.data);
              // this.$store.commit('ADD_COST', response.data)
            })
            .catch(error => {
              serverBus.$emit('showSnackbar', 'There was an Error saving Cost.', 'red')
              this.errors = error.response.data
            })
        }
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/artworks/LoanConditions.vue